export * from "./TruncatedTooltip";
